import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gwc29r2uee: FaireBrandEntity = {
  token: "b_gwc29r2uee",
  type: "brand",
  name: "Tough Kitty Designs",
  avatarUrl:
    "https://cdn.faire.com/fastly/fb19a8e2efee783d43a8c41199564cfe412e54e660f641ba5603b7816128b07e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ffb6aefdf5277f91d66f2050a075227b5d17c2764e39a2a364a8d3c7baf71b0a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/fb19a8e2efee783d43a8c41199564cfe412e54e660f641ba5603b7816128b07e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ffb6aefdf5277f91d66f2050a075227b5d17c2764e39a2a364a8d3c7baf71b0a.jpeg",
  location: "Tucson, AZ, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 34,
  isTopShop: true,
  isInsider: true,
  description:
    "Tough Kitty Designs began in 2019 in the heart of the Southwest; Tucson, Arizona. Gathering inspiration from the Sonoran Desert, pop culture, art history and metaphysics, TKD creates handcrafted ceramic goods and jewelry,  collage prints, greeting cards, stickers and more!\n\nMost items are made to order at this time, and we will get everything to you as soon as possible. If you've got your eye on something that's out of stock, just let us know. Thank you! \n",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:09.576Z",
    importedBy: "entity-db-cli",
  },
};
